// @ts-nocheck

import { get } from 'lodash'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { ProfilePicture } from '../ProfilePicture'

export default class ProfileLink extends Component<any, any> {
  formatName = (name) => {
    if (!name) return ''
    let n = `${name.first || ''} ${get(name, '1.0') || ''}`
    if (n.length > 9) n = `${n.substr(0, 7)}..`
    return n
  }

  renderPhoto = () => {
    const { picture, name } = this.props

    return (
      <div>
        <ProfilePicture url={picture} />
        <p style={styles.nameContainer}>{this.formatName(name)}</p>
      </div>
    )
  }

  render() {
    const { name, list, onClick, id, altLocation } = this.props

    if (list && id)
      return (
        <Link
          key={id}
          onClick={() => onClick && onClick()}
          to={`/${list}/${id}/${altLocation || 'profile'}`}
          alt={name}
          className="lmc-profile-link"
        >
          {this.renderPhoto()}
        </Link>
      )

    return <div className="lmc-profile-link">{this.renderPhoto()}</div>
  }
}

const styles = {
  nameContainer: { fontSize: 11, color: 'black', opacity: 0.5 }
}
